<div class="relative" [style.height.px]="(ableToShow && miniatureScaledHeight < 200) ? miniatureScaledHeight : null">
  <div #container
    class="absolute pointer-events-none"
    [ngClass]="ableToShow && miniatureScaledHeight > 200 ? 'origin-top-left top-0' : null"
    [style.width.px]="printAreaWidth ?? 800"
    [style.transform]="ableToShow && miniatureElement ? ('translate(' + (isHorizontal ? '-50%, 0' : (miniatureScaledHeight > 200 ? '0, 0' : '0, -50%')) + ') scale(' + (isHorizontal ? (192/miniatureElement.clientWidth) : (122/miniatureElement.clientWidth)) + ')') : null"
  ></div>
</div>